import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface YouchuanVideoDiffusionParams {
  /**
   * 视频生成的文本描述，必填，长度必须在1-8192个字符之间
   */
  text: string;
  /**
   * 回调URL，必须以http://或https://开头
   */
  callback?: string;
}

export interface YouchuanVideoDiffusionResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * youchuan_video_diffusion
 *
 * 通过悠船视频扩散模型API创建视频生成任务。
 *
 * API Documentation: https://tob.youchuan.cn/openapi/apis/%E8%A7%86%E9%A2%91%E7%94%9F%E6%88%90/api_video_diffusion
 *
 * @example
 * ```typescript
 * import { initSeacloud, youchuanVideoDiffusion } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await youchuanVideoDiffusion({
 *   text: 'A beautiful sunset timelapse'
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 YouchuanVideoDiffusionParams 接口定义
 * @returns 生成的资源列表
 */
export async function youchuanVideoDiffusion(
  params: YouchuanVideoDiffusionParams,
): Promise<YouchuanVideoDiffusionResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'youchuan_video_diffusion',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: YouchuanVideoDiffusionResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
